import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { isNotValidUUID } from 'src/common/utils/uuidUtils';
import {
  DefaultLocation,
  NewSearchLocation,
} from 'src/global/models/NewSearchLocation';
import { getCountryWithSGFallback } from 'src/modules/ClientConfig/Selectors';
import { useCity } from 'src/modules/Opportunities/hooks/useCity';
import { getSpecialRegionsById } from 'src/modules/Opportunities/pages/Explore/Components/SearchSection/LocationSearchField/helpers';

import { getLocationByIdQuery } from '../../../graphql';

export const useSearchLocation = (
  locationQueryId: string,
  searchCityId: string
) => {
  const countryCode = useSelector(getCountryWithSGFallback);

  const { data, loading: hierarchyLocLoading } = useQuery(
    getLocationByIdQuery,
    {
      variables: {
        id: locationQueryId,
      },
      skip: !locationQueryId || isNotValidUUID(locationQueryId),
    }
  );

  const { city, loading: legacyCityLoading } = useCity(searchCityId);

  const specialRegion = getSpecialRegionsById(locationQueryId, countryCode);
  if (specialRegion) {
    return {
      searchLocation: specialRegion,
      loading: false,
    };
  }

  const getLocationObject = () => {
    if (searchCityId && city) {
      return new NewSearchLocation(city, null, null);
    } else if (locationQueryId && data) {
      return new NewSearchLocation(null, data.location, null);
    } else {
      return DefaultLocation.getDefaultLocationAll(countryCode);
    }
  };

  return {
    searchLocation: getLocationObject(),
    loading: hierarchyLocLoading || legacyCityLoading,
  };
};
